import React, { createContext, FC, useEffect, useMemo } from 'react';
import { IUserAddressesServiceProvider } from './service-provider';
import { UserAddressesWidgetStore } from './store/UserAddresses.store';
import { observer } from 'mobx-react';

import { WidgetBase } from 'src/libs/ui-kit/widget-base/WidgetBase';

import { UserAddressesTable } from './components/tables/UserAddressesTable';
import { UserAddressViewModal } from './components/modals/UserAddressViewModal';
import { UserAddressCreateModal } from './components/modals/UserContractorAddressCreateModal';
import { UserAddressEditModal } from './components/modals/UserAddressEditModal';
import { UserAddressesWidgetColumn } from './interfaces';

type TUserTypes = 'customer' | 'contractor' | 'employee' | 'partner';

interface IUserAddressesWidgetProps {
  col?: number;
  provider: IUserAddressesServiceProvider;
  userType: TUserTypes;
  columns: readonly UserAddressesWidgetColumn[];
  selectable?: boolean;
  selected?: string | null;
  disableCreation?: boolean;
  disableDeletion?: boolean;
  disableSelection?: boolean;
  readonly?: boolean;
  onSelect?(value: string): void;
  previewRowsCount?: number;
}

export const UserAddressesStoreContext = createContext<UserAddressesWidgetStore | null>(null);

export const UserAddressesWidget: FC<IUserAddressesWidgetProps> = observer((props) => {
  const store = useMemo(() => new UserAddressesWidgetStore(props.provider), [props.provider]);

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    store.loadAddresses();
  }, [store]);

  const buttons = useMemo(
    () => [
      {
        title: 'Создать',
        clickHandler: store.createAddressModal.show,
        disabled: props.disableCreation || props.readonly,
      },
    ],
    [props.disableCreation, props.readonly, store.createAddressModal.show],
  );

  return (
    <UserAddressesStoreContext.Provider value={store}>
      <WidgetBase
        col={props.col}
        title="Адреса"
        buttons={buttons}
        isLoading={store.addressesAreLoading}
        hasError={store.hasError}>
        <UserAddressesTable
          columns={props.columns}
          selectable={props.selectable}
          selected={props.selected}
          onSelect={props.onSelect}
          disableSelection={!!props.disableSelection}
          disableDeletion={!!props.disableDeletion}
          readonly={!!props.readonly}
          previewRowsCount={props.previewRowsCount}
        />
      </WidgetBase>
      <UserAddressViewModal />
      <UserAddressCreateModal />
      <UserAddressEditModal />
    </UserAddressesStoreContext.Provider>
  );
});
